import { render, staticRenderFns } from "./ModalConfirmation.vue?vue&type=template&id=373d8b1c&scoped=true"
import script from "./ModalConfirmation.vue?vue&type=script&lang=js"
export * from "./ModalConfirmation.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmation.vue?vue&type=style&index=0&id=373d8b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373d8b1c",
  null
  
)

export default component.exports